/**
 * @deprecated use {@link RgSpaceType} instead
 * Type of `SpaceInstance`
 */
var RG_TECH_TYPE;
(function (RG_TECH_TYPE) {
    RG_TECH_TYPE["TankRoomCWSSprinkler"] = "Tank Room CWS Sprinkler";
    RG_TECH_TYPE["TankRoomRWH"] = "Tank Room RWH";
    RG_TECH_TYPE["TankRoomGreyWater"] = "Tank Room Grey Water";
    RG_TECH_TYPE["ElectricalIntake"] = "Electrical Intake";
    RG_TECH_TYPE["ElectricalBackupPower"] = "Electrical Backup Power";
    RG_TECH_TYPE["ElectricalBMSComms"] = "Electrical BMS / Comms";
    RG_TECH_TYPE["BuildingThermalEnergy"] = "Building Thermal Energy";
    RG_TECH_TYPE["CentralThermalEnergy"] = "Central Thermal Energy";
    RG_TECH_TYPE["CycleStore"] = "Cycle Store";
    RG_TECH_TYPE["BinStore"] = "Bin Store";
    RG_TECH_TYPE["ElectricalMainsIntake"] = "Electrical Mains Intake";
    RG_TECH_TYPE["MechanicalPlantConsThermalStore"] = "Mechanical Plant Consolidated - Thermal Store";
    RG_TECH_TYPE["MechanicalPlantConsThermalStoreTank"] = "Mechanical Plant Consolidated - Thermal Store + Tank";
    RG_TECH_TYPE["ElectricalPlantConsIntakeComms"] = "Electrical Plant Consolidated - Intake + Comms";
    RG_TECH_TYPE["ElectricalPlantConsBackupPowerComms"] = "Electrical Plant Consolidated - Backup Power + Comms";
})(RG_TECH_TYPE || (RG_TECH_TYPE = {}));

export { RG_TECH_TYPE };
//# sourceMappingURL=rg-tech-type.js.map
